import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment } from "vue";
import _imports_0 from '@/assets/service.png';
import _imports_1 from '@/assets/totop.png';
import _imports_2 from './assets/close.png';
const _hoisted_1 = /*#__PURE__*/_createElementVNode("img", {
  alt: "客服",
  style: {
    "width": "35.04px",
    "height": "31.59px"
  },
  src: _imports_0
}, null, -1);
const _hoisted_2 = [_hoisted_1];
const _hoisted_3 = /*#__PURE__*/_createElementVNode("img", {
  alt: "返回顶部",
  style: {
    "width": "24.46px",
    "height": "24.7px"
  },
  src: _imports_1
}, null, -1);
const _hoisted_4 = {
  class: "getQuotation-bg"
};
const _hoisted_5 = {
  class: "getQuotation"
};
const _hoisted_6 = {
  style: {
    "width": "243px",
    "text-align": "right"
  }
};
const _hoisted_7 = {
  key: 0,
  class: "service-title"
};
const _hoisted_8 = {
  key: 1,
  class: "service-title"
};
const _hoisted_9 = {
  key: 2,
  class: "service-title"
};
const _hoisted_10 = {
  key: 3,
  class: "service-title"
};
const _hoisted_11 = {
  class: "formbox"
};
const _hoisted_12 = {
  style: {
    "display": "flex",
    "flex-direction": "row",
    "align-items": "flex-start"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  const _component_el_backtop = _resolveComponent("el-backtop");
  const _component_el_input = _resolveComponent("el-input");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_router_view), _createElementVNode("div", {
    class: "service",
    onClick: _cache[0] || (_cache[0] = $event => $options.serviceClick())
  }, _hoisted_2), _createVNode(_component_el_backtop, {
    right: 30,
    bottom: 20,
    class: "backtop"
  }, {
    default: _withCtx(() => [_hoisted_3]),
    _: 1
  }), _createElementVNode("div", null, [_withDirectives(_createElementVNode("div", _hoisted_4, null, 512), [[_vShow, $data.serviceShow]]), _withDirectives(_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("img", {
    onClick: _cache[1] || (_cache[1] = $event => $options.close()),
    style: {
      "width": "21.5px",
      "height": "21.5px",
      "cursor": "pointer"
    },
    src: _imports_2,
    alt: "关闭"
  })]), $data.language == 'cn' ? (_openBlock(), _createElementBlock("div", _hoisted_7, "获取报价")) : _createCommentVNode("", true), $data.language == 'en' ? (_openBlock(), _createElementBlock("div", _hoisted_8, "Get a quote")) : _createCommentVNode("", true), $data.language == 'jp' ? (_openBlock(), _createElementBlock("div", _hoisted_9, "見積の取得")) : _createCommentVNode("", true), $data.language == 'kr' ? (_openBlock(), _createElementBlock("div", _hoisted_10, "견적 얻기")) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_input, {
    class: "input inputafter",
    placeholder: $options.getname().name,
    modelValue: $data.formData.name,
    "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.formData.name = $event),
    style: {
      "height": "30px"
    }
  }, null, 8, ["placeholder", "modelValue"]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_input, {
    class: "inputbox",
    placeholder: $options.getname().area,
    modelValue: $data.formData.area,
    "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.formData.area = $event)
  }, null, 8, ["placeholder", "modelValue"])]), _createVNode(_component_el_input, {
    class: "input inputafter",
    placeholder: $options.getname().email,
    modelValue: $data.formData.email,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.formData.email = $event)
  }, null, 8, ["placeholder", "modelValue"]), _createVNode(_component_el_input, {
    class: "inputbox",
    placeholder: $options.getname().phone,
    modelValue: $data.formData.phone,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.formData.phone = $event)
  }, null, 8, ["placeholder", "modelValue"]), _createVNode(_component_el_input, {
    type: "textarea",
    rows: 3,
    class: "input inputafter",
    placeholder: $options.getname().consultingValue,
    modelValue: $data.formData.consultingValue,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.formData.consultingValue = $event)
  }, null, 8, ["placeholder", "modelValue"])]), _createElementVNode("div", {
    class: "submit-btn",
    onClick: _cache[7] || (_cache[7] = (...args) => $options.submit && $options.submit(...args))
  }, _toDisplayString($options.getname().submit), 1)], 512), [[_vShow, $data.serviceShow]])])], 64);
}